<div class="full-page">
    <router-outlet></router-outlet>
</div>
